import cn from 'classnames';
import { useEffect, useRef, useState } from 'react';

import { IPicture } from './types';

export function Picture({
  sources,
  className,
  imgClassName,
  alt = '',
  styles,
}: IPicture) {
  const imageRef = useRef<HTMLImageElement>(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  const sourceMedia = sources?.map((source) => {
    return source.minWidth ? `(min-width: ${source.minWidth}px)` : undefined;
  });
  const sourceSizes = sources?.map((source) => {
    return source.sizes ? source.sizes : undefined;
  });

  const sourceElements = sources?.map((source, i) => {
    return (
      <source
        key={i}
        srcSet={source.srcset}
        media={sourceMedia[i]}
        sizes={sourceSizes[i]}
      />
    );
  });

  useEffect(() => {
    const load = () => setImageLoaded(true);
    const _imageRef = imageRef.current;
    _imageRef?.addEventListener('load', load);
    if (_imageRef?.complete) load();
    return () => {
      _imageRef?.removeEventListener('load', load);
    };
  }, [setImageLoaded]);

  const opacity = imageLoaded ? 'opacity-100' : 'opacity-0';
  return (
    <picture
      className={cn(
        'block transition-opacity duration-500',
        className,
        opacity,
      )}
    >
      {sourceElements}
      <img
        className={cn('h-full w-full object-cover object-center', imgClassName)}
        style={styles}
        ref={imageRef}
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
        alt={alt}
        loading="lazy"
        draggable="false"
      />
    </picture>
  );
}
